import { createContext, useContext } from 'react';
import type { Permission } from '@/types/portal';

/** The signed-in staff member, as returned by `GET /cpaas/me`. */
export interface SessionUser {
  id: string;
  name: string;
  email: string;
  avatar: string | null;
  roleId: string;
  roleName: string;
  approvalsCeiling: string;
  mustChangePassword: boolean;
  permissions: Permission[];
}

export interface AuthContextValue {
  /** `loading` while an existing token is being checked on startup. */
  status: 'loading' | 'signedIn' | 'signedOut';
  user: SessionUser | null;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
  /** Replace the signed-in user, e.g. after a password change. */
  updateUser: (user: SessionUser) => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
